import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import { light, myIcons } from '@/plugins/theme'

Vue.use(Vuetify)

export default new Vuetify({
  icons: {
    ...myIcons(),
  },
  theme: {
    options: {
      customProperties: true, // this will create css variables for the theme
    },
    themes: {
      light,
    },
  },
})
